"use client";

import { useEffect } from "react";
import type { Options } from "react-scan";

export function ReactScan({ options }: { options: Options }) {
  useEffect(() => {
    if (!options.enabled) {
      return;
    }

    const loadScan = async () => {
      const { scan } = await import("react-scan");
      scan(options);
    };

    void loadScan();
  }, [options]);

  return null;
}
